import "core-js/modules/es6.array.find";

/* eslint-disable max-len */
export var categoryById = function categoryById(state) {
  return function (id) {
    return state.all.find(function (entry) {
      return entry.id === id;
    });
  };
};
export var categoriesByType = function categoriesByType(state) {
  return function (type) {
    return state.all.filter(function (entry) {
      return entry.type === type;
    });
  };
};